<div class="title">{{ 'Unix Permissions' | translate }}</div>

<ix-permissions-item
  *ngFor="let item of permissionItems"
  [item]="item"
></ix-permissions-item>
